import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/authentication/authContext';

export function AdminRoute({ children }: { children: JSX.Element }) {
  const { user, backendUser, loading } = useAuth();

  if (loading) {
    return <div>Loading…</div>;
  }
  return user && backendUser?.role === 'admin' ? children : <Navigate to="/" replace />;
}